var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgYoutube = function SvgYoutube(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4156 3.25313C27.2562 2.65949 26.9437 2.11814 26.5094 1.68324C26.075 1.24834 25.5341 0.935141 24.9406 0.775C22.7562 0.1875 14 0.1875 14 0.1875C14 0.1875 5.24375 0.1875 3.05937 0.771875C2.46569 0.931497 1.92445 1.24452 1.49002 1.6795C1.05558 2.11448 0.743248 2.65611 0.584375 3.25C-1.19209e-07 5.4375 0 10 0 10C0 10 -1.19209e-07 14.5625 0.584375 16.7469C0.90625 17.9531 1.85625 18.9031 3.05937 19.225C5.24375 19.8125 14 19.8125 14 19.8125C14 19.8125 22.7562 19.8125 24.9406 19.225C26.1469 18.9031 27.0938 17.9531 27.4156 16.7469C28 14.5625 28 10 28 10C28 10 28 5.4375 27.4156 3.25313ZM11.2188 14.1875V5.8125L18.4688 9.96875L11.2188 14.1875Z",
    fill: "var(--detail-color-light-2)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube.82f9528c.svg";
export { ForwardRef as ReactComponent };